import Header from "../sidebar/Header";
import Sidebar from "../sidebar/index";
  import { useContext, useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { MainWrapper } from "./style";
import classNames from "classnames";
import { Box } from "@mui/material";
import ToastProvider, {
  ToastContext,
} from "../../contexts-hooks/providers/ToastProvider";
import ChangePasswordPopup from '../common-components/change-password/index'
import useGlobalContext from "../../contexts-hooks/hooks/useGlobalContext";

const Layout = () => {
  const [open, setOpen] = useState(true);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const { state } = useGlobalContext();
  const rightSectionClass = classNames({
    "right-section": true,
  });

  useEffect(() => {
    if ((state.user?.role === "hiring manager" || state.user?.role === "recruiter") && 
        state.user?.isFirstLogin) {
      setShowChangePassword(true);
    }
  }, [state.user]);

  const handleClosePasswordPopup = () => {
    if (!state.user?.isFirstLogin) {
      setShowChangePassword(false);
    }  };

  return (
    <MainWrapper>
      <ToastProvider>
        <Sidebar open={open} setOpen={setOpen} />
        <Box className={rightSectionClass}>
          <Header open={open} setOpen={setOpen} />
          {showChangePassword && (
            <ChangePasswordPopup
              open={showChangePassword}
              onClose={handleClosePasswordPopup}
            />
          )}
          <Box component="main">
            <Outlet />
          </Box>
        </Box>
      </ToastProvider>
    </MainWrapper>
  );
};

export default Layout;
